module.exports = function(input, value) {
  return parseInt(input, 10) + parseInt(value, 10)
}
